import { isly } from "isly";
import { Amount as _Amount } from "./Amount";
import { Code as _Code } from "./Code";
import { decimals as _decimals } from "./decimals";
import { name as _name } from "./name";
import { values as _values } from "./values";
export var Currency;
(function (Currency) {
    var _a;
    Currency.Amount = _Amount;
    Currency.Code = _Code;
    Currency.values = _values;
    _a = isly
        .string("value", ...Currency.values)
        .rename("isoly.Currency")
        .bind(), Currency.type = _a.type, Currency.is = _a.is, Currency.flawed = _a.flawed;
    function round(value, currency) {
        return Currency.Amount.create(currency, value).value;
    }
    Currency.round = round;
    function add(currency, left, right) {
        return Currency.Amount.add(currency, left, right).value;
    }
    Currency.add = add;
    function subtract(currency, minuend, subtrahend) {
        return Currency.Amount.subtract(currency, minuend, subtrahend).value;
    }
    Currency.subtract = subtract;
    function multiply(currency, amount, multiplicand) {
        return Currency.Amount.multiply(currency, amount, multiplicand).value;
    }
    Currency.multiply = multiply;
    function convert(currency, amount, factor, output) {
        return Currency.Amount.convert(currency, amount, factor, output).value;
    }
    Currency.convert = convert;
    function divide(currency, amount, denominator) {
        return Currency.Amount.divide(currency, amount, denominator).value;
    }
    Currency.divide = divide;
    function toMinor(amount, currency) {
        const decimals = Currency.decimalDigits(currency);
        return typeof decimals == "number" ? Math.round(amount * 10 ** decimals) : amount;
    }
    Currency.toMinor = toMinor;
    function fromMinor(amount, currency) {
        const decimals = Currency.decimalDigits(currency);
        return typeof decimals == "number" ? Currency.divide(currency, amount, 10 ** decimals) : amount;
    }
    Currency.fromMinor = fromMinor;
    function isRounded(amount, currency) {
        const decimals = Currency.decimalDigits(currency);
        return decimals == undefined
            ? true
            : isNaN(amount)
                ? false
                : (amount.toString().split(".")[1]?.length ?? 0) <= decimals;
    }
    Currency.isRounded = isRounded;
    Currency.decimalDigits = _decimals;
    Currency.name = _name;
})(Currency || (Currency = {}));
//# sourceMappingURL=index.js.map